// extracted by mini-css-extract-plugin
export default {"mailtoLink":"mailtoLink_mailtoLink__xiBUK"};